[
  { "year": 2023, "filingStatus": "Head of Household", "to": 59750, "taxRate": 0 },
  { "year": 2023, "filingStatus": "Head of Household", "to": 523050, "taxRate": 0.15 },
  { "year": 2023, "filingStatus": "Head of Household", "to": null, "taxRate": 0.2 },
  { "year": 2023, "filingStatus": "Married Filing Jointly", "to": 89250, "taxRate": 0 },
  { "year": 2023, "filingStatus": "Married Filing Jointly", "to": 553850, "taxRate": 0.15 },
  { "year": 2023, "filingStatus": "Married Filing Jointly", "to": null, "taxRate": 0.2 },
  { "year": 2023, "filingStatus": "Married Filing Separately", "to": 44625, "taxRate": 0 },
  { "year": 2023, "filingStatus": "Married Filing Separately", "to": 276900, "taxRate": 0.15 },
  { "year": 2023, "filingStatus": "Married Filing Separately", "to": null, "taxRate": 0.2 },
  { "year": 2023, "filingStatus": "Single Taxpayers", "to": 44625, "taxRate": 0 },
  { "year": 2023, "filingStatus": "Single Taxpayers", "to": 492300, "taxRate": 0.15 },
  { "year": 2023, "filingStatus": "Single Taxpayers", "to": null, "taxRate": 0.2 },
  { "year": 2024, "filingStatus": "Head of Household", "to": 63000, "taxRate": 0 },
  { "year": 2024, "filingStatus": "Head of Household", "to": 551350, "taxRate": 0.15 },
  { "year": 2024, "filingStatus": "Head of Household", "to": null, "taxRate": 0.2 },
  { "year": 2024, "filingStatus": "Married Filing Jointly", "to": 94050, "taxRate": 0 },
  { "year": 2024, "filingStatus": "Married Filing Jointly", "to": 583750, "taxRate": 0.15 },
  { "year": 2024, "filingStatus": "Married Filing Jointly", "to": null, "taxRate": 0.2 },
  { "year": 2024, "filingStatus": "Married Filing Separately", "to": 47025, "taxRate": 0 },
  { "year": 2024, "filingStatus": "Married Filing Separately", "to": 291850, "taxRate": 0.15 },
  { "year": 2024, "filingStatus": "Married Filing Separately", "to": null, "taxRate": 0.2 },
  { "year": 2024, "filingStatus": "Single Taxpayers", "to": 47025, "taxRate": 0 },
  { "year": 2024, "filingStatus": "Single Taxpayers", "to": 518900, "taxRate": 0.15 },
  { "year": 2024, "filingStatus": "Single Taxpayers", "to": null, "taxRate": 0.2 },
  { "year": 2025, "filingStatus": "Head of Household", "to": 64750, "taxRate": 0 },
  { "year": 2025, "filingStatus": "Head of Household", "to": 566700, "taxRate": 0.15 },
  { "year": 2025, "filingStatus": "Head of Household", "to": null, "taxRate": 0.2 },
  { "year": 2025, "filingStatus": "Married Filing Jointly", "to": 96700, "taxRate": 0 },
  { "year": 2025, "filingStatus": "Married Filing Jointly", "to": 600050, "taxRate": 0.15 },
  { "year": 2025, "filingStatus": "Married Filing Jointly", "to": null, "taxRate": 0.2 },
  { "year": 2025, "filingStatus": "Married Filing Separately", "to": 48350, "taxRate": 0 },
  { "year": 2025, "filingStatus": "Married Filing Separately", "to": 300000, "taxRate": 0.15 },
  { "year": 2025, "filingStatus": "Married Filing Separately", "to": null, "taxRate": 0.2 },
  { "year": 2025, "filingStatus": "Single Taxpayers", "to": 48350, "taxRate": 0 },
  { "year": 2025, "filingStatus": "Single Taxpayers", "to": 533400, "taxRate": 0.15 },
  { "year": 2025, "filingStatus": "Single Taxpayers", "to": null, "taxRate": 0.2 }
]
